
import { Vue, Component, Prop } from "vue-property-decorator";

import DocumentProvider from "@/components/documents/DocumentProvider.vue";
import { Document, User } from "@/generated/graphql";

import ConfirmRemovingDocumentModal from "@/components/documents/ConfirmRemovingDocumentModal.vue";
import Processing from "@/components/common/Processing.vue";

import SearchableListConfig from "@/entities/SearchableListConfig";
import searchableListConfig from "@/data/searchableListConfig";
import PDFIcon from '@/components/icons/PdfFileIcon.vue'

@Component({
  components: {
    DocumentProvider,
    Processing,
    ConfirmRemovingDocumentModal,
    PDFIcon
  },
  // apollo: {
  //     update(data) {
  //       this.searchableListConfig.total = data.total.aggregate.count;
  //       this.searchableListConfig.loadedCount = data.document.length;
  //       return data.document;
  //     },
  //   },
})
export default class DocumentTable extends Vue {
  @Prop({ type: Object, required: true }) readonly documents!: Document[];
  @Prop({ type: Boolean, default: false }) readonly frozen!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isCustomHeight: boolean;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Boolean, default: false }) readonly extraInfoHidden!: boolean;
   @Prop({ type: Boolean, default: false }) readonly isProject!: boolean;
  @Prop({ type: String, default: undefined }) readonly customRequestId?: string;
  @Prop({ type: String, default: undefined }) readonly classCarePlan?: string;

  searchableListConfig: SearchableListConfig = { ...searchableListConfig };

  removeDocument(remove: Function) {
    if (this.frozen) {
      return;
    }
    remove();
  }
get fileType () {
	return
}
    get getheight() {
      if(this.classCarePlan){
      return this.classCarePlan;
      }
    if(this.isCustomHeight){
      return 'customScrollDocManager';
    }
    else if(this.isProject){
      return 'customScrollDocProj';
    }
    else{
      return 'customScrollDoc';
    }
    }

  isFrozen(document: Document): boolean {
    if (this.frozen) {
      return true;
    }

    if (this.currentUser.role === "ADMIN") {
      return false;
    }

    if (this.customRequestId) {
      return false;
    }

    return this.currentUser.id !== document.uploaded_by;
  }
  formatDate(dateToBeFormatted: string): string {
    const dateObj = new Date(dateToBeFormatted);

    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const formattedDateString = dateObj.toLocaleDateString("en-US", options);

    return formattedDateString;
  }
  getDocumentSize(size) {
    size = (Number(size) / 1024).toFixed(1).replace(".0", "");

    return `${size} kB`;
  }
  // async updateDocumentList(): Promise<void>{
  //     this.$emit("listChanged");
  //     await this.$apollo.queries.documents.refetch();
  //     this.$emit("documentNumberChanged", this.searchableListConfig.total)
  //   }
}
